import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentUser, selectIsCustomer } from '@components/Auth';
import { mergeInitialValues } from '@utils/formik';

import { useFormParams, useFormValues, FormValuesForCreate } from '../HealthQuoteBuyForm';
import { selectHealthQuoteBuyRoute } from '../selector';

export const useInitialValues = () => {
  const currentUser = useSelector(selectCurrentUser);
  const isCustomer = useSelector(selectIsCustomer);
  const { healthQuote } = useSelector(selectHealthQuoteBuyRoute);
  const params = useFormParams();
  const values = useFormValues();
  const valuesForCreate: FormValuesForCreate = { ...values, planId: '', activationDate: '' };
  return useMemo(() => {
    if (!currentUser) return;
    if (!healthQuote) return;
    const { members, healthPlanId } = healthQuote;
    return mergeInitialValues(
      valuesForCreate,
      isCustomer ? { me: currentUser } : undefined,
      { ...healthQuote, ...members, planId: healthPlanId },
      params
    );
  }, [currentUser, healthQuote]);
};
